import { Combobox } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';

const DropdownSelect = ({ value, options, onChange, widthClass = 'w-24', disabled = false, glow = false, size = 'sm', placeholder = '—' }) => {
  const heightClass = size === 'lg' ? 'h-10 text-sm' : 'h-8 text-xs';
  const optionPadding = size === 'lg' ? 'px-3 py-2 text-sm' : 'px-3 py-1.5 text-xs';
  return (
    <Combobox value={value} onChange={onChange} disabled={disabled}>
      <div className={`relative ${widthClass}`}>
        <Combobox.Button className={`w-full ${heightClass} flex items-center justify-between border border-gray-200/70 bg-surface dark:bg-gray-870 dark:border-gray-600/70 px-2.5 rounded-md font-medium text-gray-700 dark:text-gray-200 hover:border-gray-300 dark:hover:border-gray-600 disabled:opacity-50 disabled:cursor-not-allowed ${glow ? 'animate-horizon-pulse' : ''}`}>
          <span>{options.find((o) => o.value === value)?.label ?? placeholder}</span>
          <ChevronDownIcon className="h-3.5 w-3.5 text-gray-400" />
        </Combobox.Button>
        <Combobox.Options className={`absolute z-20 mt-1 w-full max-h-60 overflow-auto rounded-md bg-white dark:bg-gray-870 py-1 shadow-lg ring-1 ring-black ring-opacity-5`}>
          {options.map((opt) => (
            <Combobox.Option
              key={opt.value}
              value={opt.value}
              disabled={opt.disabled}
              title={opt.disabled ? 'No data for this horizon' : undefined}
              className={({ active, selected, disabled: isDisabled }) =>
                `${optionPadding} ${
                  isDisabled
                    ? 'cursor-not-allowed text-gray-400 dark:text-gray-600'
                    : `cursor-pointer ${active ? 'bg-brand-600 text-white' : 'text-gray-800 dark:text-gray-100'}`
                } ${selected ? 'font-semibold' : ''}`
              }
            >
              {opt.label}
            </Combobox.Option>
          ))}
        </Combobox.Options>
      </div>
    </Combobox>
  );
};

export default DropdownSelect;
